import christmasParty from './../assets/images/Functions/christmasParty.JPG'
import specialOccasion from './../assets/images/Functions/specialOccasion.JPG'
import charityEvent from './../assets/images/Functions/charityEvent.JPG'
import celebrationOfLife from './../assets/images/Functions/celebrationOfLife.JPG'
import corporateEvent from './../assets/images/Functions/corporateEvents.JPG'
import foxTextSplitter from './../assets/images/Splitters/foxTextSplitter.webp'

const events = [
  {
    name: "Special Occasions",
    description: "Whether you're marking a milestone birthday, celebrating a new arrival, or commemorating years of love, our venue is the perfect place for your special occasion. We offer catering tailored to your taste from our kitchen, ensuring every dish is made to perfection. Enjoy exclusive access to a private bar and room, creating a personal and intimate atmosphere for you and your guests. From the décor to the service, we make every detail count so you can relax and focus on what matters most—making memories.",
    image: specialOccasion,
  },
  {
    name: "Christmas Parties",
    description: "Get ready for an unforgettable FOXMAS Christmas celebration! Upon arrival, you'll be greeted with a refreshing festive punch to kick off the evening. Enjoy a fantastic lineup of live performers that will set the mood, followed by a delicious festive plated hot buffet filled with seasonal favorites. Indulge your sweet tooth with an array of mouthwatering desserts, and dance the night away to the music spun by our DJ. FOXMAS promises to be the ultimate party, filled with joy, laughter, and unforgettable memories — it's the Christmas celebration you won't want to miss!",
    image: christmasParty,
  },

  {
    name: "Charity Events",
    description: "Host your next charity event in a venue that combines elegance with purpose. Whatever you're organizing, our space provides the perfect backdrop to bring people together for a good cause. With catering options to suit your needs and a private bar and room for your guests, we ensure your event runs smoothly, so you can focus on what matters most—making an impact. Let us help you create an unforgettable experience that not only supports your cause but also leaves a lasting impression on everyone who attends.",
    image: charityEvent,
  },
  {
    name: "Celebration of Life",
    description: "A Celebration of Life is a deeply personal and meaningful occasion, and our venue provides the perfect setting to honor and remember a loved one. With a warm, supportive atmosphere, we offer a space for reflection, remembrance, and shared memories. Whether you choose a simple gathering or a larger celebration, we provide catering options tailored to your wishes, along with access to a private bar and room for your guests. Let us help you create a heartfelt tribute that celebrates the life and legacy of those who meant the most to you.",
    image: celebrationOfLife,
  },
  {
    name: "Corporate Events",
    description: "Elevate your next corporate event with a venue that blends professionalism with style. Whether you're hosting a business conference, networking event, or an awards night, our function room provides the perfect setting. With customizable catering from our kitchen, a private bar, and a dedicated space tailored to your needs, we ensure a seamless and productive experience. From small meetings to large corporate celebrations, let us help you create an event that leaves a lasting impression on your guests and colleagues.",
    image: corporateEvent,
  },
];

const EventCards = () => {
    return (
        <div className="mx-auto p-6">
            <div className="text-center">
                <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">Host Your Perfect Event in Our Function Room</h1>
                <p className="text-xl text-gray-600">
                    Whether it's a festive Christmas party, a special occasion, a charity event, or a celebration of life, our versatile function room is the perfect setting for your next event. Explore the various events we can host for you below.
                </p>
            </div>
            <div className='flex justify-center py-6'>
                <img src={foxTextSplitter} alt="fox divider" className='w-[800px]' />
            </div>
            <div className="grid grid-cols-1 gap-10 p-6 md:max-w-[90%] mx-auto">
            {events.map((event, index) => (
                <div
                key={index}
                className={`relative flex flex-col md:flex-row md:h-[500px] items-center overflow-hidden rounded-2xl shadow-xl transition-transform transform hover:scale-105 bg-white ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`}
                >
                <div className="md:w-1/2 h-full overflow-hidden">
                    <img
                    src={event.image}
                    alt={event.name}
                    className="w-full h-full object-cover transition-opacity hover:opacity-90"
                    />
                </div>
                <div className="md:w-1/2 p-6 md:p-10 text-center md:text-left">
                    <h2 className="text-4xl font-bold text-gray-900 mb-3">{event.name}</h2>
                    <p className="text-lg text-gray-600 leading-relaxed">{event.description}</p>
                </div>
                </div>
            ))}
            </div>
        </div>
    );
  };
  
  export default EventCards;
